import { useQuery } from '@tanstack/react-query';

import {
  fetchAdminClaims,
  type IAdminClaimsParams,
  type IAdminClaimsResponse,
} from '@/services/admin';

export function useAdminClaims(params: IAdminClaimsParams = {}, options?: { enabled?: boolean }) {
  const { data, isLoading, isFetching, error, refetch } = useQuery<IAdminClaimsResponse, Error>({
    queryKey: ['adminClaims', params],
    queryFn: () => fetchAdminClaims(params),
    enabled: options?.enabled !== false,
  });

  const errorStatus =
    error && 'response' in error
      ? ((error as { response?: { status?: number } }).response?.status ?? null)
      : null;

  return {
    data: data ?? null,
    loading: isLoading,
    refetching: isFetching && !isLoading,
    error: error?.message ?? null,
    errorStatus,
    refetch,
  };
}
